import { useEffect } from 'react';

import PlatformRetailersModelMC from '../models/PlatformRetailersModelMC';
import { setElementHidden } from '../utils/elementVisibility';

const TIKTOK_CONNECT_BADGE_ID = 'tiktok-connect-badge';

const TikTokNavBadgeSyncMC = () => {
  useEffect(() => {
    let cancelled = false;

    PlatformRetailersModelMC.getStatus()
      .then((data) => {
        if (cancelled) return;

        const connected = data?.tik_tok_messages_integrated === true
          || data?.tik_tok_comments_integrated === true;
        if (connected) {
          setElementHidden(TIKTOK_CONNECT_BADGE_ID, true);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
};

export default TikTokNavBadgeSyncMC;
